<template>
    <div>
        <default-button icon="x" size="xxs" color="red" :loading="loading" v-bind="$props"
                        @click.native.stop="showModal = true" :label="$t('form.delete')">
            <slot></slot>
        </default-button>

        <element-modal :open="showModal" @close="showModal = false" :title="modalTitle">
            <template #body v-if="modalContent">
                <slot name="modal-body">
                    {{ modalContent }}
                </slot>
            </template>

            <template #footer>
                <default-button class="ml-2" icon="x-circle" size="xxs" color="red" @click.native.stop="triggerDelete" :loading="loading">
                    {{ $t('form.delete') }}
                </default-button>
            </template>
        </element-modal>
    </div>
</template>

<script>
export default {
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        modalTitle: String,
        modalContent: String,
    },

    data() {
        return {
            showModal: false,
        };
    },

    methods: {
        triggerDelete() {
            this.$emit('delete', true);
            this.showModal = false;
        }
    },
};
</script>
